angular.module('dpw.components').component('dpwAutomaticSetup', {
    templateUrl: 'dpw-automatic-setup.component.html',
    controllerAs: 'ctrl',
    bindings: {
        application: '<',
        conversationName: '<',
        baseIframeUrl: '<',
        webhookUrl: '<',
        onToggleMode: '&',
        onCancel: '&',
        onFinish: '&',
    },
    controller: ['postMessageManager', 'dpwToastService', '$sce', '$element', '$scope',
        function (postMessageManager, dpwToastService, $sce, $element, $scope) {
            var self = this;
            var SUBMIT_CHANNEL = 'INTEGRATION_SUBMIT_CHANNEL';
            var OAUTH_CHANNEL = 'INTEGRATION_OAUTH_CHANNEL';
            var INTEGRATION_OAUTH_FRAME = 'INTEGRATION_OAUTH_FRAME';
            var DEFAULT_ERROR_MESSAGE = 'Errors occurred, please try again or try manual installation instructions';

            self.postMessageRef = null;
            self.finishButtonDisabled = true;
            self.finishButtonLoading = false;
            self.iframeUrl = '';

            self.$onInit = function () {
                self.iframeUrl = buildIframeUrl();
            };

            self.$postLink = function () {
                setTimeout(function () {
                    var iframeElement = $element[0].querySelector('iframe');

                    if (iframeElement) {
                        iframeElement.addEventListener('load', function () {
                            self.onIframeLoad(iframeElement.contentWindow);
                        });

                        iframeElement.addEventListener('error', function () {
                            self.onIframeLoad(iframeElement.contentWindow);
                        });
                    }
                });
            };

            self.onIframeLoad = function (contentWindow) {
                self.postMessageRef = postMessageManager.create({
                    contentWindow: contentWindow,
                    targetOrigin: self.baseIframeUrl || '*',
                });

                self.postMessageRef.on(OAUTH_CHANNEL, onOauth);
            };

            self.sendFinishSignal = function () {
                if (!self.postMessageRef) {
                    return;
                }

                self.finishButtonLoading = true;

                self.postMessageRef.invoke(SUBMIT_CHANNEL).then(function (response) {
                    var payload = _.get(response, 'payload');
                    var success = _.get(payload, 'status');
                    var error = _.get(response, 'error');

                    if (success) {
                        self.onFinish();
                    } else {
                        showErrorToast(error);
                    }
                }).catch(function (err) {
                    var error = _.get(err, 'error');
                    showErrorToast(error);
                }).finally(function () {
                    self.finishButtonLoading = false;
                });
            };

            function buildIframeUrl() {
                var urlSearchParams = new URLSearchParams({
                    webhook: self.webhookUrl,
                    frameName: INTEGRATION_OAUTH_FRAME,
                });

                var url = new URL(self.baseIframeUrl);
                url.search = urlSearchParams.toString();
                return $sce.trustAsResourceUrl(url.toString());
            }

            function onOauth(payload) {
                var success = _.get(payload, 'status');

                $scope.$apply(function () {
                    self.finishButtonDisabled = !success;
                });
            }

            function showErrorToast(content) {
                dpwToastService.showToast(content || DEFAULT_ERROR_MESSAGE, {
                    extraClass: 'dpw-set-up-app-toast-container dpw-set-up-app-toast-error',
                    showCloseBtn: true,
                    disappearTime: 2000
                });
            }
    }]
});
